import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../js/void.mjs';
import { AbstractMutableSetthfi6jds1k2h as AbstractMutableSet } from './AbstractMutableSet.mjs';
import { UnsupportedOperationException2tkumpmhredt3 as UnsupportedOperationException } from '../exceptions.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../hacks.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../Unit.mjs';
import { AbstractMutableCollections0bg6c40ztuj as AbstractMutableCollection } from './AbstractMutableCollectionJs.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var HashMapKeysDefault$iterator$1Class;
function HashMapKeysDefault$iterator$1() {
  if (HashMapKeysDefault$iterator$1Class === VOID) {
    class $ {
      constructor($entryIterator) {
        this.da_1 = $entryIterator;
      }
      n1() {
        return this.da_1.n1();
      }
      o1() {
        return this.da_1.o1().e2();
      }
      l6() {
        return this.da_1.l6();
      }
    }
    initMetadataForClass($);
    HashMapKeysDefault$iterator$1Class = $;
  }
  return HashMapKeysDefault$iterator$1Class;
}
var HashMapKeysDefaultClass;
function HashMapKeysDefault() {
  if (HashMapKeysDefaultClass === VOID) {
    class $ extends AbstractMutableSet() {
      static t7(backingMap) {
        var $this = this.y7();
        $this.s7_1 = backingMap;
        return $this;
      }
      ea(element) {
        throw UnsupportedOperationException().i5('Add is not supported on keys');
      }
      v(element) {
        return this.ea((element == null ? true : !(element == null)) ? element : THROW_CCE());
      }
      v3() {
        return this.s7_1.v3();
      }
      e9(element) {
        return this.s7_1.n3(element);
      }
      t1(element) {
        if (!(element == null ? true : !(element == null)))
          return false;
        return this.e9((element == null ? true : !(element == null)) ? element : THROW_CCE());
      }
      m1() {
        var entryIterator = this.s7_1.d2().m1();
        return new (HashMapKeysDefault$iterator$1())(entryIterator);
      }
      t3(element) {
        this.k6();
        if (this.s7_1.n3(element)) {
          this.s7_1.t3(element);
          return true;
        }
        return false;
      }
      w3(element) {
        if (!(element == null ? true : !(element == null)))
          return false;
        return this.t3((element == null ? true : !(element == null)) ? element : THROW_CCE());
      }
      p1() {
        return this.s7_1.p1();
      }
      k6() {
        return this.s7_1.k6();
      }
    }
    initMetadataForClass($, 'HashMapKeysDefault');
    HashMapKeysDefaultClass = $;
  }
  return HashMapKeysDefaultClass;
}
var HashMapValuesDefault$iterator$1Class;
function HashMapValuesDefault$iterator$1() {
  if (HashMapValuesDefault$iterator$1Class === VOID) {
    class $ {
      constructor($entryIterator) {
        this.fa_1 = $entryIterator;
      }
      n1() {
        return this.fa_1.n1();
      }
      o1() {
        return this.fa_1.o1().f2();
      }
      l6() {
        return this.fa_1.l6();
      }
    }
    initMetadataForClass($);
    HashMapValuesDefault$iterator$1Class = $;
  }
  return HashMapValuesDefault$iterator$1Class;
}
var HashMapValuesDefaultClass;
function HashMapValuesDefault() {
  if (HashMapValuesDefaultClass === VOID) {
    class $ extends AbstractMutableCollection() {
      static w7(backingMap) {
        var $this = this.i6();
        $this.v7_1 = backingMap;
        return $this;
      }
      p9(element) {
        throw UnsupportedOperationException().i5('Add is not supported on values');
      }
      v(element) {
        return this.p9((element == null ? true : !(element == null)) ? element : THROW_CCE());
      }
      o9(element) {
        return this.v7_1.o3(element);
      }
      t1(element) {
        if (!(element == null ? true : !(element == null)))
          return false;
        return this.o9((element == null ? true : !(element == null)) ? element : THROW_CCE());
      }
      m1() {
        var entryIterator = this.v7_1.d2().m1();
        return new (HashMapValuesDefault$iterator$1())(entryIterator);
      }
      p1() {
        return this.v7_1.p1();
      }
      k6() {
        return this.v7_1.k6();
      }
    }
    initMetadataForClass($, 'HashMapValuesDefault');
    HashMapValuesDefaultClass = $;
  }
  return HashMapValuesDefaultClass;
}
//region block: exports
export {
  HashMapKeysDefault as HashMapKeysDefaultd8xopyn6vbgh,
  HashMapValuesDefault as HashMapValuesDefault3j1xghpfb6bpq,
};
//endregion

//# sourceMappingURL=HashMapEntryDefault.mjs.map
